import { render, staticRenderFns } from "./PageContainerFluid.vue?vue&type=template&id=0377630e&scoped=true"
import script from "./PageContainerFluid.vue?vue&type=script&lang=js"
export * from "./PageContainerFluid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0377630e",
  null
  
)

export default component.exports